/**
 * The editor dock's API surface: template placeholders.
 *
 * docs' own assistant (chat, actions, skills, connectors, evidence) moved to
 * zehn-aip; its panel is framed in the dock (components/AipPanelFrame.jsx).
 * These paths go through the app's axios stack (`useLoad` / `usePostRequest`
 * from shared/hooks/requests.js) like every other docs call.
 */

// Template placeholders (axios): definitions on a template, filled values on
// a document created from it. Values travel as [{key, value}] LISTS — humps
// would camelize a slug-keyed object.
export const FILE_PLACEHOLDERS = 'embed/v1/file/{file_id}/placeholders';
export const FILE_PLACEHOLDER_VALUES = 'embed/v1/file/{file_id}/placeholders/values';
export const FILE_PLACEHOLDER_PLACEMENTS = 'embed/v1/file/{file_id}/placeholders/placements';
